import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { NgModule, PipeTransform, Provider, Type } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SuperTabsModule } from '@ionic-super-tabs/angular';
import { IonicModule } from '@ionic/angular';
import { SharedComponentsModule } from 'apps/idl/src/components/sharedComponents.module';
import { IdlPipeModule } from '../../pipes/idlPipes.module';
import { ActesModule } from '../actes/actes.module';
import { OlaqinModule } from '../olaqin/olaqin.module';
import { SceModule } from '../sce/sce.module';
import { PatientNamePipe } from './pipes/patient-name.pipe';
import { ExportService } from './services/export.service';
import { FavoritesModule } from '../preferences/favorites/favorites.module';
import { PipeModule } from '../../pipes';

const modules: Type<any>[] = [
	IonicModule,
	CommonModule,
	IdlPipeModule,
	PipeModule,
	SharedComponentsModule,
	MatFormFieldModule,
	MatInputModule,
	MatTooltipModule,
	FormsModule,
	SuperTabsModule,
	ActesModule,
	FavoritesModule,
	ScrollingModule,
	MatRadioModule,
	OlaqinModule,
	MatAutocompleteModule,
	MatSelectModule,
	SceModule
];
const components: Type<any>[] = [
];
const providers: Provider[] = [
	ExportService,
	TitleCasePipe,
];
const pipes: Type<PipeTransform>[] = [
	PatientNamePipe
];

@NgModule({
	imports: modules,
	exports: [...components, ...pipes],
	declarations: [...components, ...pipes],
	providers: [...providers, ...pipes]
})
export class PatientsModule { }